import {Body2} from '@ui/atoms/typography';
import {CancelIcon} from '@ui/atoms/icons';
import {FilterIcon} from '@ui/atoms/icons/filter-icon';

interface ReportingFilterToggleProps {
  isOpen: boolean;
  onToggle: () => void;
}

export const ReportingFilterToggle = ({
  isOpen,
  onToggle,
}: ReportingFilterToggleProps) => {
  const label = isOpen ? 'Hide report filters' : 'Show report filters';

  return (
    <button
      type="button"
      aria-controls="reporting-filter-panel"
      aria-expanded={isOpen}
      aria-label={label}
      title={label}
      onClick={onToggle}
      className="h-10 shrink-0 rounded-[10px] border border-borderDark bg-white px-3 flex items-center gap-2 text-purple300 hover:bg-backgroundLight focus:outline-none focus:ring-2 focus:ring-purple300 focus:ring-offset-2">
      {isOpen ? (
        <CancelIcon color="currentColor" />
      ) : (
        <FilterIcon stroke="currentColor" />
      )}
      <Body2 kind="textBody" weight="semibold" className="hidden sm:block">
        {isOpen ? 'Hide filters' : 'Show filters'}
      </Body2>
    </button>
  );
};
